export interface QuestionOptionObject {
  label: string;
  inputLabel?: string;
  inputType?: string;
  placeholder: string;
  required: boolean;
  isUnder18Option?: boolean;
}

export type QuestionOption = string | QuestionOptionObject;
export type QuestionType = 'text' | 'contact' | 'emoji' | 'yes/no' | 'booking' | 'rating' | 'bonus' | 'social';
export type QuestionCategory = 'text' | 'boolean' | 'emoji' | 'rating' | 'star' | 'scale' | 'nps';
export type ReportKey = 'general_setup' | 'valuable_talk' | 'attend_future_talks' | 'book_speakers' | 'confirm_interest' | 'contact_information' | 'rating_actionable' | 'rating_engaging' | 'rating_interactive' | 'rating_inspiring' | 'rating_relevant' | 'collect_contact_info' | 'collect_title_org' | 'opportunity_details' | 'describe_talk' | 'what_else' | 'bonus' | 'social_meeting_links' | 'text_question' | 'yes_no_question' | 'emoji_question' | 'rating_question' | 'star_rating_question' | 'booking_question' | 'bonus_question' | 'social_question' | 'contact_question' | 'session_value' | 'immediate_application' | 'engagement_level' | 'topic_relevance' | 'memorable_insight' | 'recommendation_likelihood' | 'speaker_style' | 'scale_rating_question' | 'nps_question';
// export type QuestionOptionObject = Extract<QuestionOption, { required: boolean }>;
export interface IQuestion {
  _id: string;
  priority: number;
  label: string;
  description?: string;
  type: QuestionType;
  category: QuestionCategory;
  options?: QuestionOption[];
  reportKey: ReportKey;
  canSkip: boolean;
  isAnswerPublic: boolean;
  isDefault: boolean;
  isMovable: boolean;
  hasBeenCustomized: boolean;
  isEnabled: boolean;
  isCustom?: boolean;
  originalQuestion?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

// Type guards for question options
export const isQuestionOptionObject = (option: QuestionOption): option is QuestionOptionObject => {
  return typeof option === 'object' && option !== null && 'label' in option;
};

export const isStringOption = (option: QuestionOption): option is string => {
  return typeof option === 'string';
};

export const safeGet = (obj: Record<string, any>, key: string): string => obj[key] || '';
